function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96,
  r: 80,
  fill: "#f4f4f4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96 54.54a2 2 0 01-2-2v-17a2 2 0 014 0v17a2 2 0 01-2 2zM52.37 98h-17a2 2 0 010-4h17a2 2 0 010 4zM156.37 98h-17a2 2 0 010-4h17a2 2 0 010 4zM65.11 67.28a2 2 0 01-1.41-.59l-12-12a2 2 0 012.83-2.83l12 12a2 2 0 01-1.41 3.41z",
  fill: "#4a4d4e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96 80a16 16 0 1016 16 16 16 0 00-16-16m18 16a18 18 0 11-18-18 18 18 0 0118 18z",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96,
  r: 12,
  fill: "#e60000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "9fbe3dd3-f280-4eca-bbdb-7dd977045c0c",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8.42,
  d: "M136 56.5l-31.27 31.27"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var SvgDashboardHi = function SvgDashboardHi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, /*#__PURE__*/React.createElement("path", {
    d: "M176 95v1a80 80 0 01-160 0v-1a80 80 0 00160 0z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _ref2, _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M138.38 53.09l37.38 37C175.9 92 176 94 176 96a79.87 79.87 0 01-32 64l-56.9-56z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref4, _ref5, /*#__PURE__*/React.createElement("path", {
    d: "M140.1 55.48a4.19 4.19 0 01-1.1 4l-31.29 31.27-.14.11a12 12 0 00-.53-1.57 4.22 4.22 0 00.67-.54L139 57.48a4.17 4.17 0 001.1-2zM107.95 95a6.7 6.7 0 01.05 1 12 12 0 01-24 0c0-.34.05-.67.05-1a12 12 0 0023.9 0z",
    fill: "#bd0000",
    style: {
      isolation: "isolate"
    }
  }), _ref6);
};

export default SvgDashboardHi;